import { useLocation } from "wouter";
import ArrowUpRight from "@/components/icons/ArrowUpRight";
import Browser from "@/components/icons/Browser";
import XIcon from "@/components/icons/XIcon";
import Telegram from "@/components/icons/Telegram";
import ContractAddress from "@/components/icons/ContractAddress";
import bgLandingPage from "@/assets/images/bg_landing_page.png";
import { useAuthStore } from "@/hooks/useAuthStore";
import IconDiscord from '@/assets/icons/discord.svg';
import { trackEvent } from '@/utils/analytics';
import { EventAction } from '@/types/analytics';
import { getXDaoHomePath } from "@/lib/utils";

export default function Landing() {
  const [, setLocation] = useLocation();
  const { isAuthenticated } = useAuthStore();

  const handleNavigate = (path: string) => {
    if (isAuthenticated) {
      // User is authenticated, navigate directly
      setLocation(path);
    } else {
      // User is not authenticated, redirect to login with intended destination
      setLocation(`/login?redirect=${path}`);
    }
  };

  const links = [
    {
      id: "x-dao",
      name: "X DAO",
      subtitle: "tweetonium.xyz/xdao",
      icon: "browser",
      enabled: true,
      customGradient: "linear-gradient(to bottom, rgba(135, 62, 208, 1), rgba(16, 29, 74, 1))",
      onClick: () => {
        trackEvent('ui_interaction', EventAction.LINK_CLICK, {
          label: 'xdao_navigation',
          component: 'landing_page',
          location: 'links_card',
          link_type: 'internal',
          destination: getXDaoHomePath()
        });
        handleNavigate(getXDaoHomePath());
      },
    },
    // {
    //   id: "web-app",
    //   name: "Web App",
    //   subtitle: "tweetonium.xyz/app",
    //   icon: "browser",
    //   enabled: true,
    //   customGradient: "linear-gradient(to bottom, rgba(135, 62, 208, 1), rgba(16, 29, 74, 1))",
    //   onClick: () => handleNavigate("/app"),
    // },
    {
      id: "x-tweetonium",
      name: "X",
      subtitle: "@tweetonium_xyz",
      icon: "x",
      enabled: true,
      customGradient: "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0)), linear-gradient(to bottom, rgba(47, 47, 52, 1), rgba(24, 24, 27, 1))",
      onClick: () => {
        trackEvent('ui_interaction', EventAction.LINK_CLICK, {
          label: 'social_x_tweetonium',
          component: 'landing_page',
          location: 'links_card',
          link_type: 'external',
          destination: 'https://x.com/tweetonium_xyz'
        });
        window.open("https://x.com/tweetonium_xyz", "_blank");
      },
    },
    {
      id: "x-tweetminting",
      name: "X",
      subtitle: "@TweetMinting",
      icon: "x",
      enabled: true,
      customGradient: "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0)), linear-gradient(to bottom, rgba(47, 47, 52, 1), rgba(24, 24, 27, 1))",
      onClick: () => {
        trackEvent('ui_interaction', EventAction.LINK_CLICK, {
          label: 'social_x_tweetminting',
          component: 'landing_page',
          location: 'links_card',
          link_type: 'external',
          destination: 'https://x.com/TweetMinting'
        });
        window.open("https://x.com/TweetMinting", "_blank");
      },
    },
    {
      id: "discord-tweetonium",
      name: "Discord",
      subtitle: "discord.gg/AwnD3tYb7X",
      icon: "discord",
      enabled: true,
      customGradient: "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0)), linear-gradient(to bottom, rgba(47, 47, 52, 1), rgba(24, 24, 27, 1))",
      onClick: () => {
        trackEvent('ui_interaction', EventAction.LINK_CLICK, {
          label: 'social_discord',
          component: 'landing_page',
          location: 'links_card',
          link_type: 'external',
          destination: 'https://discord.gg/AwnD3tYb7X'
        });
        window.open("https://discord.gg/AwnD3tYb7X", "_blank");
      },
    },
    {
      id: "telegram",
      name: "Telegram",
      subtitle: "@Tweetonium",
      icon: "telegram",
      enabled: true,
      customGradient: "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0)), linear-gradient(to bottom, rgba(42, 171, 238, 1), rgba(18, 81, 112, 1))",
      onClick: () => {
        trackEvent('ui_interaction', EventAction.LINK_CLICK, {
          label: 'social_telegram',
          component: 'landing_page',
          location: 'links_card',
          link_type: 'external',
          destination: 'https://t.me/tweetonium'
        });
        window.open("https://t.me/tweetonium", "_blank");
      },
    },
    {
      id: "contract-address",
      name: "Contract Address",
      subtitle: "Gs7qfkwi4pfimnPvdxK4ik6kDarBEAJZEQivEdJaPLqm",
      icon: "contract-address",
      enabled: true,
      customGradient: "linear-gradient(to bottom, rgba(48, 57, 63, 1), rgba(26, 26, 30, 1)), linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0))",
      onClick: () => {
        trackEvent('ui_interaction', EventAction.LINK_CLICK, {
          label: 'contract_dexscreener',
          component: 'landing_page',
          location: 'links_card',
          link_type: 'external',
          destination: 'https://dexscreener.com/solana/Gs7qfkwi4pfimnPvdxK4ik6kDarBEAJZEQivEdJaPLqm'
        });
        window.open("https://dexscreener.com/solana/Gs7qfkwi4pfimnPvdxK4ik6kDarBEAJZEQivEdJaPLqm", "_blank");
      },
    },
  ];

  return (
    <div
      style={{
        backgroundImage: `
          url(${bgLandingPage}),
          linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0)),
          linear-gradient(to bottom, rgba(47, 47, 52, 1), rgba(1, 1, 1, 1))
        `,
        backgroundSize: 'cover, auto, auto',
        backgroundRepeat: 'repeat, no-repeat, no-repeat',
        backgroundPosition: 'center',
      }}
      className="min-h-screen flex items-center justify-center p-4"
    >
      <div className="w-full md:w-auto">
        {/* Logo and Beta Badge */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-2">
            <h1 className="text-4xl md:text-5xl font-bold tiny5-font text-white">
              TWEETONIUM
            </h1>
            <span className="bg-purple-600 text-white text-xs font-bold px-2 py-1 rounded">
              BETA
            </span>
          </div>
        </div>

        {/* Links Card */}
        <div
          style={{
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, rgba(255, 255, 255, 0.00) 256.26%)',
          }}
          className="backdrop-blur-[12.6px] rounded-3xl p-4 md:p-10 border border-white/20 shadow-2xl"
        >
          <div className="space-y-4 md:space-y-10">
            {links.map((link) => (
              <button
                key={link.id}
                onClick={link.onClick}
                disabled={!link.enabled}
                style={link.customGradient ? { background: link.customGradient } : undefined}
                className={`w-full max-w-[420px] md:max-w-[500px] rounded-[16px] px-6 py-[18px] pr-14 mx-auto ${link.enabled ? "hover:opacity-90 cursor-pointer" : "opacity-50 cursor-not-allowed"}
                  transition-all duration-200 flex items-center justify-between relative`}
              >
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  <div>
                    {link.icon === "browser" ? (
                      <Browser className="w-10 h-10" />
                    ) : link.icon === "x" ? (
                      <XIcon className="w-10 h-10" />
                    ) : link.icon === "telegram" ? (
                      <Telegram className="w-10 h-10" />
                    ) : link.icon === "contract-address" ? (
                      <ContractAddress className="w-10 h-10" />
                    ) : link.icon === 'discord' ? (
                        <img
                          src={IconDiscord}
                          alt="Discord"
                          className="w-10 h-10"
                        />
                    ) : null}
                  </div>
                  <div className="text-left flex-1 min-w-0">
                    <div className="font-inter font-bold text-[16px] text-white">{link.name}</div>
                    {link.subtitle && (
                      <div className={`font-inter font-normal text-[12px] text-gray-300/80 truncate ${
                        link.icon === "contract-address"
                          ? "md:overflow-visible md:whitespace-normal"
                          : ""
                      }`}>
                        {link.subtitle}
                      </div>
                    )}
                  </div>
                </div>
                <ArrowUpRight className="w-6 h-6 text-white/70 absolute top-3 right-3" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
